import { LogLevel } from "@azure/msal-browser";
import { backendRequestJson } from "./backend";

export const msalConfig = {
  auth: {
    // A1: michael's private tenant
    // clientId: "9afd212b-efe6-42d4-b784-5ca129db9a5f",
    // authority:
    //   "https://login.microsoftonline.com/24c39db7-4348-4c46-9da7-518fa736da4b",

    // A2: bk tenant
    clientId: "7b0ec6d9-dbdb-409a-8306-e2f3972c32d4",
    authority:
      "https://login.microsoftonline.com/468fdde2-ee97-4ad8-bedd-99d9394a8ade",

    // B1: dev redirects (local server, `npm run dev`)
    // redirectUri: "http://localhost:5173",
    // postLogoutRedirectUri: "http://localhost:5173",

    // B2: dev redirects (local web server)
    // redirectUri: "http://localhost:8118",
    // postLogoutRedirectUri: "http://localhost:8118",

    // B3: prod redirects (deployed web server)
    redirectUri: "https://bravokilo.ch",
    postLogoutRedirectUri: "https://bravokilo.ch",
  },
  cache: {
    cacheLocation: "localStorage",
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            // console.info(message);
            return;
          case LogLevel.Verbose:
            // console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

/**
 * Scopes to prompt the user for consent during sign-in. By default, msal.js will add
 * OIDC scopes (openid, profile, email) to any login request. Docs:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ["User.Read"], //, "Mail.Read"],
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

/**
 * Sign out the current user
 */
export const signOutActiveUser = async (instance) => {
  // tell the backend to delete the session
  await backendRequestJson("GET", "/auth/logout", null, null, false).catch((e) => {
    console.error("Failed to logout from backend:", e);
  });

  // find active account
  let targetAccount = instance.getActiveAccount();
  if (!targetAccount) {
    const accounts = instance.getAllAccounts();
    if (accounts.length == 0) {
      console.warn("No active account and no accounts to log out of at all!");
      return;
    }
    if (accounts.length > 0) {
      targetAccount = accounts[0];
      console.log(
        "No active account for logout. Using first account instead:",
        targetAccount
      );
    }
  }

  instance
    .logoutRedirect({
      account: targetAccount,
      onRedirectNavigate: () => {
        return false; // stop navigation after local logout
      },
    })
    .then(() => {
      console.log("User logged out.");
    })
    .catch((e) => {
      console.error("Logout failed:", e);
      console.error("> target account:", targetAccount);
    });
};
